export interface OperationalDivision {
  id: string
  name: string
  code: string
  description?: string | null
  color_code: string
  sort_order?: number | null
  service_types?: string[] | null
  is_active: boolean
}

export interface DivisionScopedRecord {
  operational_division_id?: string | null
  service_type?: string | null
}

export function resolveOperationalDivision(
  serviceType: string | null | undefined,
  divisions: OperationalDivision[]
): OperationalDivision | null {
  const normalized = serviceType?.trim()
  if (!normalized) return null

  return (
    [...divisions]
      .sort(
        (a, b) =>
          (a.sort_order ?? 100) - (b.sort_order ?? 100) || a.name.localeCompare(b.name)
      )
      .find((division) => division.service_types?.includes(normalized)) || null
  )
}

export function resolveOperationalDivisionId(
  serviceType: string | null | undefined,
  divisions: OperationalDivision[]
): string | null {
  return resolveOperationalDivision(serviceType, divisions)?.id || null
}

/** Matches assigned rows and legacy rows that have not yet been backfilled. */
export function recordMatchesDivision(
  record: DivisionScopedRecord,
  division: OperationalDivision | null
): boolean {
  if (!division) return true
  if (record.operational_division_id) {
    return record.operational_division_id === division.id
  }
  return !!record.service_type && !!division.service_types?.includes(record.service_type)
}

export function buildDivisionPostgrestFilter(division: OperationalDivision): string {
  const serviceTypes = (division.service_types || []).join(',')
  if (!serviceTypes) return `operational_division_id.eq.${division.id}`
  return `operational_division_id.eq.${division.id},and(operational_division_id.is.null,service_type.in.(${serviceTypes}))`
}
